import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type TemplateGridItemFragment = { __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null };

export type GetTemplateGridItemsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  take?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.TemplateFilterInput>;
  orderBy?: Types.InputMaybe<Array<Types.TemplateOrderByInput> | Types.TemplateOrderByInput>;
}>;


export type GetTemplateGridItemsQuery = { __typename: 'Query', templatesCount: number, templates: Array<{ __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null } | null> };

export type UpdateTemplateGridMutationVariables = Types.Exact<{
  input: Types.MutationUpdateTemplateInput;
}>;


export type UpdateTemplateGridMutation = { __typename: 'Mutation', updateTemplate: { __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null } };

export type CreateTemplateForGridMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateInput;
}>;


export type CreateTemplateForGridMutation = { __typename: 'Mutation', createTemplate: { __typename: 'Template', id: string, legacyId: number, name?: string | null, state: Types.TemplateState, articleId?: string | null, type: Types.TemplateType, public: boolean, comment?: string | null, galleryImage?: { __typename: 'DataObject', id: string } | null, organization: { __typename: 'Organization', name?: string | null, id: string, legacyId: number }, latestRevision?: { __typename: 'TemplateRevision', id: string, legacyId: number, completed: boolean, createdAt: string, graph?: any | null, createdBy?: { __typename: 'User', id: string } | null, renderedImages: Array<{ __typename: 'DataObject', id: string }> } | null } };

export type CreateTemplateRevisionForGridMutationVariables = Types.Exact<{
  input: Types.MutationCreateTemplateRevisionInput;
}>;


export type CreateTemplateRevisionForGridMutation = { __typename: 'Mutation', createTemplateRevision: { __typename: 'TemplateRevision', id: string, legacyId: number } };

export const TemplateGridItemFragmentDoc = gql`
    fragment TemplateGridItem on Template {
  id
  legacyId
  name
  state
  articleId
  galleryImage {
    id
  }
  type
  public
  comment
  organization {
    name
    id
    legacyId
  }
  latestRevision {
    id
    legacyId
    completed
    createdAt
    graph
    createdBy {
      id
    }
    renderedImages(take: 4) {
      id
    }
  }
}
    `;
export const GetTemplateGridItemsDocument = gql`
    query getTemplateGridItems($skip: Int, $take: Int, $filter: TemplateFilterInput, $orderBy: [TemplateOrderByInput!]) {
  templates(skip: $skip, take: $take, filter: $filter, orderBy: $orderBy) {
    ...TemplateGridItem
  }
  templatesCount(filter: $filter)
}
    ${TemplateGridItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplateGridItemsGQL extends Apollo.Query<GetTemplateGridItemsQuery, GetTemplateGridItemsQueryVariables> {
    override document = GetTemplateGridItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateGridDocument = gql`
    mutation updateTemplateGrid($input: MutationUpdateTemplateInput!) {
  updateTemplate(input: $input) {
    ...TemplateGridItem
  }
}
    ${TemplateGridItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateGridGQL extends Apollo.Mutation<UpdateTemplateGridMutation, UpdateTemplateGridMutationVariables> {
    override document = UpdateTemplateGridDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateForGridDocument = gql`
    mutation createTemplateForGrid($input: MutationCreateTemplateInput!) {
  createTemplate(input: $input) {
    ...TemplateGridItem
  }
}
    ${TemplateGridItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateForGridGQL extends Apollo.Mutation<CreateTemplateForGridMutation, CreateTemplateForGridMutationVariables> {
    override document = CreateTemplateForGridDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateRevisionForGridDocument = gql`
    mutation createTemplateRevisionForGrid($input: MutationCreateTemplateRevisionInput!) {
  createTemplateRevision(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateRevisionForGridGQL extends Apollo.Mutation<CreateTemplateRevisionForGridMutation, CreateTemplateRevisionForGridMutationVariables> {
    override document = CreateTemplateRevisionForGridDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }